module.exports = __webpack_public_path__ + "img/mynetstar.37e0f627.svg";